import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import Layout from '../layout/Layout';
import { useStripe } from '@stripe/react-stripe-js';
import { axiosInstanceWithToken } from '@/helpers/axios';
import { successPopup } from '@/helpers';

const BookingStatusComponent = () => {
    const [searchParams] = useSearchParams();
    const stripe = useStripe();

    const redirect_status = searchParams.get('redirect_status');
    const paymentIntent = searchParams.get('payment_intent');
    const payment_intent_client_secret = searchParams.get('payment_intent_client_secret');
    // Get the referring page URL
    const referrer = document.referrer;

    const [statusMessage, setStatusMessage] = useState('Checking payment status...');

    useEffect(() => {
        try {
            if (redirect_status === 'succeeded' && payment_intent_client_secret && stripe) {
                const formData = new FormData();
                formData.append('payment_intent_id', paymentIntent);
                axiosInstanceWithToken.post('/payment/charge/capture', formData).then((res) => {
                    if (res?.data?.status) {
                        successPopup('', `
                            Your Payment has been approved, awaiting the booking confirmation by the host or the capture of payment.
                            `);
                        setStatusMessage('Payment Captured.');
                    }
                })
            } else {
                // Handle other redirect_status values or missing data
                switch (redirect_status) {
                    case 'failed':
                        setStatusMessage('Payment failed.');
                        break;
                    case 'canceled':
                        setStatusMessage('Payment was canceled.');
                        break;
                    default:
                        setStatusMessage('Checking payment status....');
                        break;
                }
            }
        } catch (error) {
            console.log(error)
        }
    }, [redirect_status, payment_intent_client_secret, stripe, paymentIntent]);

    // Extract listing ID from the referrer URL using a regular expression
    const getListingIdFromReferrer = (referrerUrl) => {
        const match = referrerUrl.match(/\/listing\/(\d+)/);
        return match ? match[1] : null; // Return the ID if found, otherwise null
    };


    return (
        <Layout>
            <div className="max-w-md py-4 mx-auto overflow-hidden bg-white rounded-lg shadow-lg my-44">
                <div className="px-6 py-4">
                    <h2 className="mb-2 text-2xl font-bold">Booking Status</h2>
                    <div className="space-y-2">
                        <div className="flex justify-between">
                            <span className="font-semibold">Status:</span>
                            <span>{statusMessage}</span>
                        </div>
                    </div>
                </div>
                <Link to={`/trip`} className='bg-[#8ec639] w-full text-white hover:text-white decoration-none px-4 py-2 ms-5 rounded-sm'>
                    Return to your trips
                </Link>
            </div>
        </Layout>
    );
};

export default BookingStatusComponent;
